import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => {
  const { primary } = theme.palette;

  return {
    header: {
      display: "flex",
      color: "#595a5a",
      alignItems: "center",
      justifyContent: "space-between",
      [theme.breakpoints.up("md")]: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        fontSize: 14,
        height: 46,
        minHeight: 46,
        marginBottom: 0,
        padding: "0 16px"
      }
    },
    headerTitle: {
      fontSize: 16,
      lineHeight: "46px",
      marginRight: 10,
      color: primary.main,
      [theme.breakpoints.up("md")]: {
        marginRight: 6,
        fontSize: 14
      }
    },
    markAll: {
      fontSize: 14,
      color: primary.dark,
      textTransform: "none",
      marginRight: -8,
      [theme.breakpoints.up("md")]: {
        fontSize: 12
      }
    },
    matchesCount: {
      position: "relative",
      bottom: 2,
      height: 18,
      width: 18,
      backgroundColor: theme.palette.warning.dark
    }
  };
});
